import React from 'react';
import Link from 'react-router-dom/Link';

export default class SignupForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.email = '';
		this.password = '';
		this.loading = false;
		this.confirmPassword = '';
		this.errorMessage = '';
		this.isResearcher = false;
	}

	async submit(){
		this.app.startLoadingForm(this);
		try{
			this.app.validate(this.password === this.confirmPassword, 'Passwords must match.');
			this.app.validate(this.password && this.password.length >= 6, 'Passwords must be at least 6 characters long.');

			const result = await this.app.http.createUser({
				username:  this.email,
				email:     this.email,
				password:  this.password,
				userType:  this.isResearcher ? 'researcher' : 'participant',
			});

			//UserSub:"069f8fdf-a704-474c-811f-02285d893f0f"
			//username:"test_gmail.com"
			this.app.validate(!!result.CodeDeliveryDetails, "There was an error signing up. Please try again.")

			this.app.loginForm.reset();
			this.app.loginForm.username = this.username;
			this.reset();
			this.app.goToMessagePage({
				title: 'Please check your email',
				body: (<div>An email has been sent to {`${result.CodeDeliveryDetails.Destination}`}. Please click on the link to "Verify Email", then <Link to="/login">click here to sign in</Link>.</div>)
			});
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/SignupForm.js